import React from 'react';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { SITE_CONFIG, WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
const included = ['Diseño personalizado', 'Dominio por un año', 'Hosting por un año', 'WhatsApp conectado', 'Ubicación y redes sociales', 'Hasta seis secciones', 'Hasta diez servicios o veinte productos', 'Carrito hacia WhatsApp cuando aplique', 'Control básico de disponibilidad', 'Diseño adaptable a celular', 'Dos rondas de revisión', 'Soporte por treinta días', 'Entrega estimada en siete días hábiles'];
export function PriceSection() {
  return <section id="precio" className="bg-[#0c0c1c] py-16 md:py-20" aria-labelledby="precio-title" data-id="element-1093">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-1094">
        <div className="text-center" data-id="element-1095">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-1096">
            Precio claro
          </p>
          <h2 id="precio-title" className="text-3xl font-bold text-white md:text-5xl" data-id="element-1097">
            Tu Página A-Z por{' '}
            <span className="text-gradient-cosmic" data-id="element-1098">
              {SITE_CONFIG.product.price}
            </span>
          </h2>
          <p className="mt-4 text-lg text-[#a9a9ba]" data-id="element-1099">
            Un pago único por diseño, configuración y publicación.
          </p>
        </div>

        <article className="relative mt-9 overflow-hidden rounded-2xl border border-[#a738f4]/35 bg-[#101022] p-6 shadow-xl shadow-black/20 md:p-8" data-id="element-1100">
          <div className="pointer-events-none absolute -right-24 -top-24 h-56 w-56 rounded-full bg-[#a738f4]/15 blur-3xl" data-id="element-1101" />
          <div className="relative" data-id="element-1102">
            <p className="text-sm font-semibold uppercase tracking-[0.14em] text-[#d58aff]" data-id="element-1103">
              Producto principal
            </p>
            <h3 className="mt-2 text-2xl font-bold text-white md:text-3xl" data-id="element-1104">
              {SITE_CONFIG.product.name}
            </h3>

            <div className="mt-5 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-1105">
              <p className="font-orbitron text-4xl font-bold text-white sm:text-5xl" data-id="element-1106">
                {SITE_CONFIG.product.price}
              </p>
              <p className="pb-1 text-sm font-medium text-[#c9c9d6]" data-id="element-1107">
                Pago único
              </p>
            </div>

            <div className="mt-5 rounded-xl border border-white/10 bg-black/15 p-4 text-sm leading-relaxed text-[#d4d4df]" data-id="element-1108">
              <p className="font-semibold text-white" data-id="element-1109">Forma de pago</p>
              <p className="mt-1.5" data-id="element-1110">{SITE_CONFIG.product.paymentPolicy}</p>
            </div>

            <div className="mt-7" data-id="element-1111">
              <h4 className="text-lg font-semibold text-white" data-id="element-1112">Incluye</h4>
              <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-1113">
                {included.map(item => <li key={item} className="flex gap-2 text-sm text-[#d4d4df]" data-id="element-1114">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-[#20d6e8]" data-id="element-1115" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <a href={createWhatsAppUrl(WHATSAPP_MESSAGES.price)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('whatsapp_price_click', {
            cta_location: 'price',
            selected_product: SITE_CONFIG.product.name
          })} className="mt-7 inline-flex min-h-14 w-full items-center justify-center gap-2 rounded-xl bg-[#25d366] px-6 py-4 text-center font-semibold text-[#06170c] transition-colors hover:bg-[#3ee47a] focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1116">
              <MessageCircleIcon className="h-5 w-5 flex-none" data-id="element-1117" />
              Comenzar mi página por ₡120.000
            </a>

            <p className="mt-4 rounded-lg border-l-2 border-[#e92a88] bg-[#e92a88]/5 p-4 text-sm text-[#d6c6d0]" data-id="element-1118">
              Funcionalidades especiales se cotizan por separado.
            </p>
            <p className="mt-3 text-center text-xs leading-relaxed text-[#89899b]" data-id="element-1119">
              Sin mensualidad obligatoria durante el primer año. La renovación
              anual del dominio y hosting se cotiza antes del vencimiento.
            </p>
          </div>
        </article>
      </div>
    </section>;
}